<template>
  <div class="record-list-box-box">
    <!--          顶部选择-->
    <div class="filter-input">
      <el-input
        v-if="!selectPlayPick"
        prefix-icon="el-icon-search"
        size="mini"
        placeholder="输入关键字进行过滤"
        v-model="filterText"
        @change="changeText"
      >
      </el-input>
    </div>

    <!--          树选择-->
    <div>
      <div
        v-if="selectPlayPick"
        class="record-list-box"
        :style="recordListStyle"
      >
        <div style="margin-left: 10px; margin-top: -12px">
          <i class="el-icon-back" style="cursor: pointer" @click="back()"></i>
          <span style="margin-left: 36px; font-size: 14px">选择回放日期</span>
          <div>
            <el-date-picker
              size="mini"
              style="width: 250px; margin-top: 10px"
              v-model="chooseDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="日期"
              @change="dateChange()"
            ></el-date-picker>
          </div>
        </div>
        <ul v-if="detailFiles.length != 0">
          <li style="margin-left: 10px; margin-top: -3px">{{ companyName }}</li>
          <ul>
            <li style="margin-left: 20px">{{ shipName }}</li>
            <ul>
              <li style="margin-left: 30px">{{ position }}</li>
              <ul
                v-if="detailFiles.length > 0"
                class="infinite-list record-list"
                style="background-color: #051427"
              >
                <li
                  v-for="item in detailFiles"
                  class="infinite-list-item record-list-item"
                >
                  <el-tag v-if="chooseFile != item" @click="checkedFile(item)">
                    <i class="el-icon-video-camera"></i>
                    {{ moment(item.startTime).format("HH:mm:ss") }}-{{
                      moment(item.endTime).format("HH:mm:ss")
                    }}
                  </el-tag>
                  <el-tag v-if="chooseFile == item" type="danger">
                    <i class="el-icon-video-camera"></i>
                    {{ moment(item.startTime).format("HH:mm:ss") }}-{{
                      moment(item.endTime).format("HH:mm:ss")
                    }}
                  </el-tag>
                </li>
              </ul>
            </ul>
          </ul>
        </ul>
      </div>

      <el-tree
        v-else
        :style="recordListStyle"
        class="record-list-box"
        node-key="value"
        :data="companyList"
        :default-expanded-keys="defaultExpandIds"
        :props="{ lable: 'name' }"
        @node-click="handleNodeClick"
        ref="tree"
      >
      </el-tree>
    </div>
    <div
      size="mini"
      v-if="selectPlayPick && detailFiles.length == 0"
      class="record-list-no-val"
    >
      暂无数据
    </div>
    <div
      size="mini"
      v-if="selectPlayPick && companyList.length == 0"
      class="record-list-no-val"
    >
      暂无数据
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
  props: ["isToken", "mediaServiceToken"],
  data() {
    return {
      BASE_URL: "http://cctv.hbrytech.cn:2123/prod-api/",
      // BASE_URL: "http://192.168.1.122:2023",
      MEDIA_URL: "https://gbs.hbrytech.cn:18080",
      // 回放相关数据
      filterText: "",
      companyList: [],
      defaultExpandIds: [], // 这里存放要默认展开的节点 id

      selectPlayPick: false,

      deviceId: "",
      channelId: "",
      companyName: "",
      shipName: "",
      position: "",

      streamId: "",
      hasAudio: false,
      detailFiles: [],
      chooseDate: null,
      videoUrl: null,
      chooseFile: null,
      streamInfo: null,
      app: null,
      mediaServerId: null,
      ssrc: null,
      userInfo: [],

      sliderMIn: 0,
      sliderMax: 86400,
      autoPlay: true,
      taskUpdate: null,
      tabVal: "running",
      recordListStyle: {
        height: this.winHeight + "px",
        overflow: "auto",
        marginTop: "5px",
        marginLeft: "2px",
        color: "white",
        backgroundColor: "#03050c",
        width: "100%",
      },
      playerStyle: {
        margin: "0 auto 20px auto",
        height: this.winHeight + "px",
      },
      winHeight: window.innerHeight - 200,
      playTime: null,
      timeRange: null,
      startTime: null,
      endTime: null,
      playTimeSliderMarks: {
        0: "00:00",
        3600: "01:00",
        7200: "02:00",
        10800: "03:00",
        14400: "04:00",
        18000: "05:00",
        21600: "06:00",
        25200: "07:00",
        28800: "08:00",
        32400: "09:00",
        36000: "10:00",
        39600: "11:00",
        43200: "12:00",
        46800: "13:00",
        50400: "14:00",
        54000: "15:00",
        57600: "16:00",
        61200: "17:00",
        64800: "18:00",
        68400: "19:00",
        72000: "20:00",
        75600: "21:00",
        79200: "22:00",
        82800: "23:00",
        86400: "24:00",
      },
    };
  },
  created() {},
  mounted() {
    this.recordListStyle.height = this.winHeight + "px";
    this.playerStyle["height"] = this.winHeight + "px";
    this.chooseDate = moment().format("YYYY-MM-DD");
    window.addEventListener("beforeunload", this.stopPlayRecord);
  },
  methods: {
    resetPlayer() {
      this.chooseDate = null;
      this.timeRange = null;
      this.playTime = null;
      this.sliderMax = 86400;
      this.sliderMIn = 0;
      this.detailFiles = [];
    },
    changeText(val) {
      console.log(val, "vvvvvvvvv");
      this.$refs.tree.filter(val);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    getUserInfo() {
      axios({
        url: this.$root.BASE_URL + "/system/user/profile",
        method: "get",
        headers: {
          authorization: this.isToken,
        },
      }).then((res) => {
        console.log(res, "rrrrrrrrrrrrrrr");
        this.userInfo = res.data.data;
        // 查询公司-船舶/码头-摄像头信息
        this.getCompanyList();
      });
    },
    // 获取公司-船舶-摄像头信息
    getCompanyList() {
      let data = {
        roleId: this.userInfo.roles[0].roleId,
        userId: this.userInfo.userId,
        deptId: this.userInfo.deptId,
      };
      axios({
        url: this.$root.BASE_URL + "/work/sy/company/list",
        method: "post",
        data,
        headers: {
          authorization: this.isToken,
        },
      }).then((res) => {
        this.companyList = res.data.data;
        let boxStr = "box_";
        this.companyList.forEach((company) => {
          company.children.forEach((ship) => {
            // TODO 添加nvr
            console.log(ship.boxCode);
            let nvrStr = `nvr_${ship.boxCode}_${ship.value}`;
            this.nvrList.push(nvrStr);

            // TODO 添加盒子
            boxStr += ship.value;
            this.aiBoxList.push(boxStr);
            boxStr = "box_";

            ship.children.forEach((camera) => {
              if (!camera) return;

              let nvrStr = this.nvrList[this.nvrList.length - 1];
              // console.log(camera);
              // 添加摄像头
              nvrStr += `_${camera.value}`;
              this.cameraList.push(nvrStr);
            });
            nvrStr = "nvr_";
          });
        });

        this.companyList.forEach((p) => {
          p.children.forEach((q) => {
            q.icon = "playImg";
            if (q.children[0] == null) {
              q.children = null;
            } else {
              q.children.forEach((qq) => {
                qq.icon = "aiMonitor";
              });
            }
          });
        });
      });
    },
    // 公司列表树 处理方法
    handleNodeClick(data, e) {
      // 判断是否是叶子结点
      if (data.children !== undefined) {
        return;
      }
      // 清空默认节点
      this.defaultExpandIds = [];
      // 请求回放数据
      this.deviceId = e.parent.data.boxCode;
      this.channelId = data.value;
      this.chooseDate = moment().format("YYYY-MM-DD");
      console.log(this.chooseDate, "this.chooseDate");
      this.dateChange();
      // 存放
      this.defaultExpandIds.push(e.parent.data.value);
      this.selectPlayPick = true;
      this.companyName = e.parent.parent.data.label;
      this.shipName = e.parent.data.label;
      this.position = data.label;
    },
    dateChange() {
      if (!this.chooseDate) {
        return;
      }
      this.setTime(
        this.chooseDate + " 00:00:00",
        this.chooseDate + " 23:59:59"
      );
      this.detailFiles = [];
      axios({
        method: "get",
        url:
          this.MEDIA_URL +
          "/api/gb_record/query/" +
          this.deviceId +
          "/" +
          this.channelId +
          "?startTime=" +
          this.startTime +
          "&endTime=" +
          this.endTime,
        headers: {
          "Access-Token": this.mediaServiceToken,
        },
      })
        .then((res) => {
          if (res.data.code === 0) {
            // 处理时间信息
            this.$nextTick(() => {
              this.detailFiles = res.data.data.recordList;
            });

            console.log(res.data.data.recordList, "resssssssssss");
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((e) => {});
    },
    setTime: function (startTime, endTime) {
      this.startTime = startTime;
      this.endTime = endTime;
      let start =
        (new Date(this.startTime).getTime() -
          new Date(this.chooseDate + " 00:00:00").getTime()) /
        1000;
      let end =
        (new Date(this.endTime).getTime() -
          new Date(this.chooseDate + " 00:00:00").getTime()) /
        1000;
      console.log(start,'start');
      console.log(end,'start');
      this.playTime = [start, end];
      this.timeRange = [startTime, endTime];
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .player-option-box .el-slider__runway {
  background-color: rgba(206, 206, 206, 0.47) !important;
}
::v-deep .player-option-box .el-slider__bar {
  background-color: rgba(153, 153, 153, 0) !important;
}
.playtime-slider {
  position: relative;
  z-index: 100;
}
.data-picker-true {
}
.data-picker-true:after {
  content: "";
  position: absolute;
  width: 4px;
  height: 4px;
  background-color: #606060;
  border-radius: 4px;
  left: 45%;
  top: 74%;
}
.el-input .el-input--mini .el-input--prefix {
  width: 100%;
}
.slider-val-box {
  height: 6px;
  position: relative;
  top: -22px;
}
.slider-val {
  height: 6px;
  background-color: #007cff;
  position: absolute;
}
.record-list-box-box {
  width: 100%;
  float: left;
}
.record-list-box {
  overflow: auto;
  width: 220px;
  list-style: none;
  padding: 0;
  margin: 0;
  margin-top: 0px;
  padding: 1rem 0;
  background-color: #03050c !important;
  margin-top: 10px;
}
.record-list {
  list-style: none;
  padding: 0;
  margin: 0;
  background-color: #03050c !important;
}
.record-list-no-val {
  position: absolute;
  color: #9f9f9f;
  top: 50%;
  left: 110px;
}
.record-list-box::-webkit-scrollbar {
  display: none; /* 隐藏滚动条 */
}

.record-list-item {
  padding: 0;
  cursor: pointer;
  background-color: #03050c;
}
.record-list-option {
  width: 10px;
  float: left;
  margin-top: 39px;
}
.player-option-box {
  padding: 0 20px;
}
.player-tools {
  height: 20px;
  width: 20px;
}
.record-list-item {
  margin-left: 40px;
  margin-top: 5px;
}
.record-list-item:first-child {
  margin-top: -1px;
}
ul li {
  list-style: none;
}
li {
  font-size: 14px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
}
* {
  padding: 0;
  margin: 0;
}
.record-list-box:nth-child(2) {
  margin-left: 20px;
}

/* el-tree 设置鼠标移上去显示的颜色 */
::v-deep .record-list-box-box .el-tree-node__content:hover {
  background-color: #409eff !important;
}

/* 点击节点时的选中颜色 */
::v-deep
  .record-list-box-box
  .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: #409eff !important;
}

/* 右键点击时的选中颜色 */
::v-deep .record-list-box-box .el-tree-node:focus > .el-tree-node__content {
  background-color: #409eff !important;
}

/* 渐变边框 */
::v-deep .el-input__inner {
  border-image: linear-gradient(to right, #011e75, #23b7cb) 5 5 !important;
  background-color: #03050c;
  color: white;
  /* 自定义其他样式时 注意加 !important 安全一些 */
}

/* 改变 两个时间的    字体颜色背景 */
::v-deep .hright .el-input__inner .el-range-input {
  background: #03050c !important;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #c0c4cc;
}

/* 改变 至 的    字体颜色背景 */
::v-deep .hright .el-input__inner .el-range-separator {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #c0c4cc;
}
::v-deep .el-tree-node:focus > .el-tree-node__content {
  background-color: #409eff !important;
}
</style>
